import styled from "styled-components";

export const Row = styled.div`
  border-top: ${({ $first }) =>
    $first ? "1px solid #dee2e6" : "0px solid #dee2e6"};
  border-bottom: 1px solid #dee2e6;
  align-items: center;
`;

export const Th = styled.div`
  border-top: ${({ $first }) =>
    $first ? "1px solid #dee2e6" : "0px solid #dee2e6"};
  border-bottom: 1px solid #dee2e6;
  align-items: center;
  background-color: #203b34;
  color: #fff;
  font-weight: 600;
`;

export const Col = styled.div`
  border-left: ${({ $first }) =>
    $first ? "1px solid #dee2e6" : "0px solid #dee2e6"};
  border-right: 1px solid #dee2e6;
  align-items: center;
  padding: 5px 15px;
  font-size: 0.8rem;
  max-width: ${({ $withMin }) => ($withMin ? "fit-content" : "initial")};
  min-height: ${({ $isHead }) => ($isHead ? "25px" : "40px")};
  align-items: center;
  display: flex;
  min-width: 55px;
`;

export const Icon = styled.i`
  margin-right: 10px;
`;

export const ButtonClose = styled.button`
  font-size: 1rem;
  border: 0px;
  background: transparent;
`;
